import React from 'react';
import { Box } from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';
import { PageHeader } from '../../components/admin';
import GlobalniVypnutiDetekceSection from '../../components/iot/GlobalniVypnutiDetekceSection';
import GlobalPrijemciSection from '../../components/iot/GlobalPrijemciSection';
import MqttSettingsSection from '../../components/iot/MqttSettingsSection';
import SiaSettingsSection from '../../components/iot/SiaSettingsSection';

const IoTSettingsPage: React.FC = () => {
    return (
        <Box>
            <PageHeader title="IoT Nastavení" icon={<SettingsIcon />} />

            <GlobalniVypnutiDetekceSection />
            <GlobalPrijemciSection />
            <MqttSettingsSection />
            <SiaSettingsSection />
        </Box>
    );
};

export default IoTSettingsPage;
